import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the collaborators state domain
 */

const selectCollaboratorsDomain = (state) =>
  state.get("collaborators", initialState)

/**
 * Other specific selectors
 */
export const makeSelectGetCollaborators = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("collaborators")
  )

export const makeSelectIsDownloading = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectCollaboratorsDomain, (state) => state.get("isUploading"))

export const makeSelectIsLoadingCollaboratorsTable = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isLoadingCollaboratorsTable")
  )

export const makeSelectHasDivisions = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("hasDivisions")
  )

export const makeSelectHasCollaborators = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("hasCollaborators")
  )

export const makeSelectHasSegments = () =>
  createSelector(selectCollaboratorsDomain, (state) => state.get("hasSegments"))

export const makeSelectCollaboratorTeam = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("collaboratorTeam")
  )

export const makeSelectIsLoadingCollaboratorTeam = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isLoadingCollaboratorTeam")
  )

export const makeSelectPotentialLeaders = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("potentialLeaders")
  )

export const makeSelectIsLoadingPotentialLeaders = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isLoadingPotentialLeaders")
  )

export const makeSelectTeamPotential = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("teamPotential")
  )

export const makeSelectIsLoadingTeamPotential = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isLoadingTeamPotential")
  )

export const makeSelectIsLoadingMeasures = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isLoadingMeasures")
  )

export const makeSelectMeasuresAffected = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("measuresAffected")
  )

export const makeSelectVismaPeopleStatus = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("vismaPeopleStatus")
  )

export const makeSelectIsLoadingVismaPeopleStatus = () =>
  createSelector(selectCollaboratorsDomain, (state) =>
    state.get("isLoadingVismaPeopleStatus")
)
/**
 * Default selector used by Collaborators
 */

const makeSelectCollaborators = () =>
  createSelector(selectCollaboratorsDomain, (substate) => substate.toJS())

export default makeSelectCollaborators
export { selectCollaboratorsDomain }
